<template>
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Города
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs6>
                <TitleTextField
                  v-model="entity.title"
                  :required="true"
                  :input-language="inputLanguage"
                  :rules="[
                    v => !!v || 'Наименование обязательно к заполнению',
                    v =>
                      v.length >= 3 ||
                      'Наименование должно содержать не менее 3-х символов'
                  ]"
                  label="Наименование*"
                  class="mx-2"
                  @input="entityChange"
                />
              </v-flex>
              <v-flex xs6>
                <CountryReference
                  v-model="entity.country"
                  :rules="[v => !!v || '']"
                  :clearable="true"
                  label="Страна*"
                  class="mx-2"
                  @input="countryChange"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <RegionReference
                  v-model="entity.region"
                  :rules="[v => !!v || '']"
                  :clearable="true"
                  :country-id="entity.country ? entity.country.id : 0"
                  label="Регион*"
                  class="mx-2"
                  @input="regionChange"
                />
              </v-flex>
              <v-flex xs6>
                <DistrictReference
                  v-model="entity.district"
                  :clearable="true"
                  :country-id="entity.country ? entity.country.id : 0"
                  :region-id="entity.region ? entity.region.id : 0"
                  label="Область"
                  class="mx-2"
                  @input="entityChange"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-layout v-if="isConfirmed === false">
            <v-btn
              small
              color="primary"
              @click="saveAndClose"
            >
              Подтвердить
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="entity.id!==0 && isConfirmed === false"
              small
              color="error"
              @click="remove(entity.id)"
            >
              Удалить
            </v-btn>
          </v-layout>

          <v-layout v-else>
            <v-btn
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="submit(false)"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="!isModal"
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="saveAndClose"
            >
              Сохранить и закрыть
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="entity.id!==0 || entity.id!==0 && isConfirmed === true"
              small
              :color="entity.isRemoved ? 'success' :'error'"
              @click="changeRemovedState"
            >
              {{ entity.isRemoved ? "Восстановить" : "Удалить" }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import RegionReference from "../regions/RegionReference.vue";
import CountryReference from "../countries/CountryReference.vue";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import DistrictReference from "../districts/DistrictReference.vue";
import * as citiesApi from "../../backend/citiesApi.js";

export default {
  components: {
    RegionReference,
    CountryReference,
    DistrictReference,
  },
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      entity: {
        id: 0,
        title: "",
        country: null,
        region: null,
        district: null,
      },
      entityRestored: false,
      resource: "cities",
      isValid: false,
      isChanged: false,
      loading: false,
    };
  },
  computed: {
    inputLanguage() {
      return this.entity.country ? this.entity.country.inputLanguage : "";
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isConfirmed() {
      if (Object.prototype.hasOwnProperty.call(this.entity, "this.entity")) {
        return this.entity.isConfirmed;
      }
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await citiesApi.getCity(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    entityChange() {
      if (!this.entityRestored && !this.isModal && this.id != 0) {
        return;
      }

      this.isChanged = true;
    },
    regionChange(payload) {
      this.entity.country = null;
      if (payload && payload.country) {
        this.entity.country = payload.country;
      }
      this.entityChange();
    },
    countryChange(payload) {
      this.entity.region = null;
      if (payload && payload.region) {
        this.entity.region = payload.region;
      }
      this.entityChange();
    },
    async submit(closeAfterSubmit) {
      const entity = {
        id: this.entity.id,
        title: this.entity.title,
        regionId: this.entity.region.id,
        districtId: this.entity.district?.id,
      };

      if (this.entity.id && this.entity.id > 0) {
        this.loading = true;
        await citiesApi.updateCity(this.resource, this.entity.id, entity);
        this.showInfo("Город изменен");
        this.isChanged = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.loading = false;
      } else {
        this.loading = true;
        const res = await citiesApi.createCity(this.resource, entity);
        this.showInfo("Город добавлен");
        this.entity.id = res.data;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
          this.$router.replace(`/${this.resource}/${res.data}`);
        }
        this.loading = false;
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.submit(true);
    },
    async changeRemovedState() {
      await citiesApi.changeRemovedState(this.resource, this.entity);
      this.entity.isRemoved = !this.entity.isRemoved;
    },
    async remove() {
      await citiesApi.deleteCity(this.resource, this.entity.id);
      this.showInfo("Город удален");
      this.$router.go(-1);
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
